export default "https://cdn.retino.com/dist/files/react/img/shipping/dpd_logo.png";